module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"postDateFormat":"Gepostet am {day}. {month} {year}"},"en":{"postDateFormat":"Posted on {month} {day}, {year}"}}')
  delete Component.options._Ctor
}
